import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImage } from '../../../../../base/publicMethod/index';
import { h5PageCount } from '../../../../../utils';
import { formatTime } from '../../utils/formatTime';
import { formatPlayNum } from '../../utils/playNumUnit';
import { formatVideoDuration } from '../../utils/formatVideoDuration';
import { getTopicData, getSurveyInfo, getSlideData, getOnlineNum } from '../../utils/api';
import imageUrl from '../../utils/imageUrl';
import { getImageUrl } from '../../utils/image';
import Grounds from '../../../../../base/grounds';

const { callApp } = require('@ifeng/callapp');

// 大图
class BigImg extends PureComponent {
    static propTypes = {
        item: PropTypes.object,
        url: PropTypes.string,
        countMapCache: PropTypes.object,
        videoPlayCache: PropTypes.object,
        isDisplaySource: PropTypes.bool,
        isNewsTime: PropTypes.bool,
        isFormatTime: PropTypes.bool,
        isCount: PropTypes.bool,
        isLazyImage: PropTypes.bool,
        observer: PropTypes.object,
    };

    static defaultProps = {
        isDisplaySource: true,
        isNewsTime: false,
        isFormatTime: false,
        isCount: true,
        isClickListItem: false,
        isLazyImage: true,
    };

    state = {
        topicCount: 0,
        topicUrl: '',
        surveyCount: 0,
        onlineNum: 0,
        slideNum: 0,
    };

    ref = React.createRef();

    async componentDidMount() {
        const {
            index,
            item,
            item: { type, base62Id, picNum },
            observer,
        } = this.props;

        const url = item['_url'] || item.url;

        this.ref.current.setAttribute('data-index', index);

        observer.observe(this.ref.current);

        if (type === 'theme') {
            try {
                const topicData = await getTopicData(url);

                this.setState({
                    topicCount: topicData.nnum && topicData.nnum.join,
                    topicUrl: topicData.shareurl,
                });
            } catch (e) {
                console.error(e);
            }
        }

        if (type === 'survey') {
            try {
                const surveyData = await getSurveyInfo(url);

                this.setState({
                    surveyCount: surveyData.surveyinfo && surveyData.surveyinfo.pnum,
                });
            } catch (e) {
                console.error(e);
            }
        }

        if (type === 'directSeeding') {
            let onlineNum = 0;

            try {
                onlineNum = await getOnlineNum(url);
            } catch (e) {
                console.error(e);
            }

            this.setState({
                onlineNum,
            });
        }

        if (type === 'slide') {
            let slideNum = 0;

            if (picNum) {
                slideNum = picNum;
            } else {
                try {
                    slideNum = await getSlideData(base62Id);
                } catch (e) {
                    console.error(e);
                }
            }

            this.setState({
                slideNum,
            });
        }
    }

    handleClick = (url, id, newstype, kind, downloads, clickCountConfig) => {
        const doc_type = newstype;
        const aid = id;
        const {
            item: { isVideoShare },
        } = this.props;
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        this.feedClickCountFn(clickCountConfig);

        callApp({
            client,
            docType: doc_type,
            pid: aid,
            kind,
            download: downloads.download,
            downloadAd: downloads.downloadAd,
        });
    };

    feedClickCountFn = (config) => {
        if (window.grounds) return Grounds.jumpInNative(this.props.item);

        if (config) {
            h5PageCount([config]);
        }
    };

    render() {
        const { topicCount, topicUrl, surveyCount, onlineNum, slideNum } = this.state;

        let { url } = this.props;
        const {
            item,
            countMapCache,
            videoPlayCache,
            isDisplaySource,
            isNewsTime,
            isFormatTime,
            isCount,
            isLazyImage,
        } = this.props;
        const {
            title,
            source,
            id,
            base62Id,
            commentUrl,
            guid,
            type,
            newsTime,
            callUp,
            linkMark,
            newstype,
            clickCount,
            kind,
            downloads,
            articleTag,
            articleTagColor,
            thumbnail,
            thumbnails,
            startTime = '',
            endTime = '',
            duration,
            bigVideo,
            liveText,
        } = item;
        const isSource = isDisplaySource && source && source !== '';
        const date = isFormatTime ? formatTime(newsTime) : newsTime;
        const clickCountConfig = clickCount ? clickCount : '';
        const videoplay = videoPlayCache && videoPlayCache[guid];
        let count = 0;

        if (type === 'theme') {
            count = topicCount;
        } else if (type === 'survey') {
            count = surveyCount;
        } else {
            count = (countMapCache && countMapCache[commentUrl]) || 0;
        }

        url = url || topicUrl;
        if (typeof window === 'object' && window.grounds) url = null;

        let image = thumbnail && thumbnail !== '' ? thumbnail : thumbnails;

        // thumbnails
        if (image && typeof image === 'object' && 'image' in image) {
            image = getImageUrl(image.image[0]);
        }

        const src = formatImage(image, 690, 346);
        const props = {};

        if (isLazyImage) {
            props.src = imageUrl.normal;
            props['data-lazy-src'] = src;
        } else {
            props.src = src;
        }

        let tagColorStyle = {};

        if (type === 'directSeeding') {
            tagColorStyle = { color: '#f54343' };
        } else if (articleTagColor) {
            switch (articleTagColor) {
                case 7:
                    tagColorStyle = { color: '#3091f5' };
                    break;
                case 8:
                    tagColorStyle = { color: '#ff7900' };
                    break;
                case 9:
                    tagColorStyle = { color: '#4bc259' };
                    break;
                case 10:
                    tagColorStyle = { color: '#f54343' };
                    break;
            }
        }

        // 直播状态
        let liveStatus = '';

        if (type === 'directSeeding') {
            const currentDate = new Date();
            const currentTime = currentDate.getTime();

            const startDate = new Date(startTime.replace(/-/g, '/'));
            const startT = startDate.getTime();

            const endDate = new Date(endTime.replace(/-/g, '/'));
            const endT = endDate.getTime();

            if (currentTime < startT) {
                liveStatus = '预约';
            } else if (currentTime > endT) {
                liveStatus = '回顾';
            } else {
                liveStatus = '直播中';
            }
        }

        if (bigVideo) {
            return (
                <div className={styles.bigVideo}>
                    <a
                        onClick={
                            callUp === 1
                                ? this.handleClick.bind(this, url, id, newstype, kind, downloads, clickCountConfig)
                                : this.feedClickCountFn.bind(this, clickCountConfig)
                        }
                        href={url}>
                        <div className={styles.mask}>
                            <div className={styles.title}>{title}</div>
                            {videoplay && <span className={styles.vcount}>{`${formatPlayNum(videoplay)}次播放`}</span>}
                        </div>
                        <img {...props} ref={this.ref} />
                        <span className={styles.playIcon} />
                        {duration && (
                            <span className={styles.videoIcon}>
                                <span>{formatVideoDuration(Number(duration))}</span>
                            </span>
                        )}
                    </a>
                </div>
            );
        }

        return (
            <div className={styles.bigImg}>
                <div className={styles.link}>
                    {callUp === 1 ? (
                        <a onClick={this.handleClick.bind(this, url, id, newstype, kind, downloads, clickCountConfig)}>
                            {title}
                        </a>
                    ) : (
                        <a href={url} onClick={this.feedClickCountFn.bind(this, clickCountConfig)}>
                            {title}
                        </a>
                    )}
                </div>
                <div className={styles.imgBox}>
                    {callUp ? (
                        <a onClick={this.handleClick.bind(this, url, id, newstype, kind, downloads, clickCountConfig)}>
                            <img {...props} ref={this.ref} />
                            {type === 'slide' && slideNum > 0 ? (
                                <span className={styles.imgIcon}>
                                    <span />
                                    <span>{slideNum}</span>
                                </span>
                            ) : (
                                ''
                            )}
                            {liveText && liveText === '直播中' && (
                                <span className={styles.liveTextIng}>{liveText}</span>
                            )}
                            {liveText && liveText === '回放' && <span className={styles.liveTextBack}>{liveText}</span>}
                            {liveText && liveText !== '直播中' && liveText !== '回放' && (
                                <span className={styles.liveText}>{liveText}</span>
                            )}
                            {type === 'video' || type === 'miniVideo' ? (
                                <Fragment>
                                    <span className={styles.playIcon} />
                                    {duration && (
                                        <span className={styles.videoIcon}>
                                            <span>{formatVideoDuration(Number(duration))}</span>
                                        </span>
                                    )}
                                </Fragment>
                            ) : (
                                ''
                            )}
                        </a>
                    ) : (
                        <a onClick={this.feedClickCountFn.bind(this, clickCountConfig)} href={url}>
                            <img {...props} ref={this.ref} />
                            {liveText && liveText === '直播中' && (
                                <span className={styles.liveTextIng}>{liveText}</span>
                            )}
                            {liveText && liveText === '回放' && <span className={styles.liveTextBack}>{liveText}</span>}
                            {liveText && liveText !== '直播中' && liveText !== '回放' && (
                                <span className={styles.liveText}>{liveText}</span>
                            )}
                            {type === 'slide' && slideNum > 0 ? (
                                <span className={styles.imgIcon}>
                                    <span />
                                    <span>{slideNum}</span>
                                </span>
                            ) : (
                                ''
                            )}
                            {type === 'video' || type === 'miniVideo' ? (
                                <Fragment>
                                    <span className={styles.playIcon} />
                                    {duration && (
                                        <span className={styles.videoIcon}>
                                            <span>{formatVideoDuration(Number(duration))}</span>
                                        </span>
                                    )}
                                </Fragment>
                            ) : (
                                ''
                            )}
                        </a>
                    )}
                </div>
                <div className={styles.info}>
                    {callUp === 1 ? (
                        <div>
                            <span
                                onClick={this.handleClick.bind(
                                    this,
                                    url,
                                    id,
                                    newstype,
                                    kind,
                                    downloads,
                                    clickCountConfig,
                                )}
                                className={styles.openApp}>
                                打开APP阅读
                            </span>
                            {linkMark && (
                                <a onClick={this.feedClickCountFn.bind(this, clickCountConfig)} href={url}>
                                    <span className={styles.wap}>网页阅读</span>
                                </a>
                            )}
                            {isCount && count !== 0 && (
                                <span className={styles.count}>{`${formatPlayNum(count)}评`}</span>
                            )}
                            {onlineNum !== 0 && (
                                <span className={styles.count}>{`${formatPlayNum(onlineNum)}人参与`}</span>
                            )}
                        </div>
                    ) : (
                        <div>
                            {liveStatus && (
                                <span style={tagColorStyle} className={styles.stickMark}>
                                    {liveStatus}
                                </span>
                            )}
                            {articleTag && (
                                <span style={tagColorStyle} className={styles.stickMark}>
                                    {articleTag}
                                </span>
                            )}
                            {isSource && <span className={styles.source}>{source}</span>}
                            {isNewsTime && <span className={styles.date}>{date}</span>}
                            {videoplay && <span className={styles.count}>{`${formatPlayNum(videoplay)}次播放`}</span>}
                            {isCount && !articleTag && count !== 0 && (
                                <span className={styles.count}>{`${formatPlayNum(count)}评`}</span>
                            )}
                            {onlineNum !== 0 && (
                                <span className={styles.count}>{`${formatPlayNum(onlineNum)}人参与`}</span>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default BigImg;
